  <!--
  If there is more than 1 panel display the panels in a soho-tabs.component
  -->
<!--
    [alternate]="true" - to get alternate styling
    [headerTabs]="true" - to get header styling margins
-->
<ng-container *ngIf="initialBuildComplete">
  <ng-container *ngIf="hasPanels && useSohoTabsComponent">
<!--    using beforeActivated as the event trigger so we build the panel before it is shown. Previously we didn't,
 and messed up the height of the page causing scrolling issues. This is to fix https://jira.lawson.com/browse/LMCLIENT-27858 -->
    <div soho-tabs #sohoTabsComponent
      class="detail-tabs"
      [disableAutoUpdatedCall]="true"
      [alternate]="isCardListDetailSections"
      [headerTabs]="isCardListDetailSections"
      [attributes]="detailSectionAttributes"
      attr.data-automation-id="lm-{{this.detailSectionAutomationIdPrefix}}-tabs"
      (beforeActivated)="onTabActivated($event)"
    >
      <div soho-tab-list-container>
        <ul soho-tab-list>
          <li soho-tab *ngFor="let panel of detailSectionPanels; trackBy: trackById; let i=index;"
            [selected]="panel.selected"
            [hidden]="panel.hidden"
            [disabled]="!panel.isValid">
            <a soho-tab-title
                attr.id="{{!testVersion1 ? panel.id + tabIdSuffix : null}}"
                attr.data-automation-id="lm-{{panel.automationId}}-tab"
                tabId="{{panel.id}}"
                attr.data-index="{{i}}"
            >{{panel.title}}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- *********************************************************************************
    NOTE: `[ngStyle]="{'height': '100%'}"` is causing tab-panel-container to be too tall.
    This is because it's overriding the height css used to calculate the proper height of
    the panel. `.pane .tab-panel-container { height: calc(100% - 40px); }`
    **************************************************************************************
    [class.no-scroll]="true" needed for the filter list to be hide-able in responsive mode
    ********************************************************************************** -->
    <div soho-tab-panel-container
        soho-busyindicator
        [text]="' '"
        [blockUI]="true"
        [displayDelay]="20"
        [timeToComplete]="this.uiLoadingIndicatorTimeout"
        [transparentOverlay]="true"
    >
      <div soho-tab-panel
          *ngFor="let panel of detailSectionPanels"
          [ngSwitch]="panel.type"
          tabId="{{panel.id}}"
          attr.data-automation-id="lm-{{panel.automationId}}-panel"
          [ngClass]="{'lm-has-detail-sections': panel?.listSpec?.busListSpec?.detailSections, 'scrollable': !panel.hasNestedCardViewDetailSections}"
      >
        <!--<ng-container *ngTemplateOutlet="switchTemplate"></ng-container>-->
        <lm-detail-section-list #detailListComponent
            *ngSwitchCase="'list'"
            [panel]="panel"
            [fromDataView]="!panel.hidden ? fromDataView : null"
            [activated]="panel.activated"
            [needsReload]="panel.needsReload"
            (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (contentModified)="onContentModified($event)"
            (panelDataUpdated)="onPanelDataUpdated($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
            (cubeDetailSectionPVPeriodEvent)="onCubeDetailSectionPVPeriodEvent($event)"
        ></lm-detail-section-list>
        <lm-detail-section-multilist #detailListComponent
            *ngSwitchCase="'multilist'"
            [panel]="panel"
            [fromDataView]="!panel.hidden ? fromDataView : null"
            [activated]="panel.activated"
            [needsReload]="panel.needsReload"
            (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (contentModified)="onContentModified($event)"
            (panelDataUpdated)="onPanelDataUpdated($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
        ></lm-detail-section-multilist>
        <lm-detail-section-card #detailListComponent
            *ngSwitchCase="'cardview'"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [activated]="panel.activated"
            [needsReload]="panel.needsReload"
            (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
        ></lm-detail-section-card>
        <lm-detail-section-form #detailListComponent
            *ngSwitchCase="'standardform'"
            [formSpec]="panel.formSpec"
            [fromDataView]="fromDataView"
            [activated]="panel.activated"
            [needsReload]="panel.needsReload"
            (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            (panelDataUpdated)="onPanelDataUpdated($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
        ></lm-detail-section-form>
        <lm-detail-section-dashboard #detailListComponent
            *ngSwitchCase="'dashboard'"
            [panels]="panel.dashBoardPanes"
            [useTwelveColumnGrid]="panel.useTwelveColumnGrid"
            [fromDataView]="fromDataView"
            [columns]="panel.dashboardColumns"
            [activated]="panel.activated"
            [needsReload]="panel.needsReload"
            (uiLinkEvent)="onUILinkEvent($event)"
            (dashboardContentDisplayed)="onDashboardContentDisplayed($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            (panelTransactionEvent)="onPanelDataUpdated($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
        ></lm-detail-section-dashboard>
        <lm-detail-section-url #detailListComponent
            *ngSwitchCase="'link'"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [activated]="panel.activated"
            [needsReload]="panel.needsReload"
            (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            (panelDataUpdated)="onPanelDataUpdated($event)"
        ></lm-detail-section-url>
        <lm-detail-section-notfound #detailListComponent
            *ngSwitchDefault
            [activated]="panel.activated"
            (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
        ></lm-detail-section-notfound>
      </div>
    </div>
  </ng-container>

  <!--
  If there is only 1 panel then no need for the soho-tabs
  TODO: have to duplicate this code since ngSwitch is being used. Can't seem to use ng-template for
  this since the template throws an error at compile time about no NGSwitch provider being defined.
  -->
  <ng-container *ngIf="hasPanels && !useSohoTabsComponent">
    <div *ngFor="let panel of visiblePanels" [ngSwitch]="panel.type" [ngStyle]="{'height': '100%'}" class="scrollable">
      <lm-detail-section-list #detailListComponent
          *ngSwitchCase="'list'"
          [panel]="panel"
          [fromDataView]="fromDataView"
          [activated]="true"
          [ngStyle]="{'height': '100%'}"
          (sendContextMessageEvent)="onSendContextMessageEvent($event)"
          (contentModified)="onContentModified($event)"
          (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
          (panelDataUpdated)="onPanelDataUpdated($event)"
          (cubeDetailSectionPVPeriodEvent)="onCubeDetailSectionPVPeriodEvent($event)"
      ></lm-detail-section-list>
      <lm-detail-section-multilist #detailListComponent
          *ngSwitchCase="'multilist'"
          [panel]="panel"
          [fromDataView]="fromDataView"
          [activated]="true"
          (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
          (sendContextMessageEvent)="onSendContextMessageEvent($event)"
          (contentModified)="onContentModified($event)"
          (panelDataUpdated)="onPanelDataUpdated($event)"
      ></lm-detail-section-multilist>
      <lm-detail-section-card #detailListComponent
          *ngSwitchCase="'cardview'"
          [panel]="panel"
          [fromDataView]="fromDataView"
          [activated]="true"
          [needsReload]="panel.needsReload"
          (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
      ></lm-detail-section-card>
      <lm-detail-section-form #detailListComponent
          *ngSwitchCase="'standardform'"
          [formSpec]="panel.formSpec"
          [fromDataView]="fromDataView"
          [activated]="true"
          [ngStyle]="{'height': '100%'}"
          (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
          (panelDataUpdated)="onPanelDataUpdated($event)"
      ></lm-detail-section-form>
      <lm-detail-section-dashboard #detailListComponent
          *ngSwitchCase="'dashboard'"
          [panels]="panel.dashBoardPanes"
          [fromDataView]="fromDataView"
          [useTwelveColumnGrid]="panel.useTwelveColumnGrid"
          [columns]="panel.dashboardColumns"
          [activated]="true"
          [ngStyle]="{'height': '100%'}"
          (uiLinkEvent)="onUILinkEvent($event)"
          (dashboardContentDisplayed)="onDashboardContentDisplayed($event)"
          (sendContextMessageEvent)="onSendContextMessageEvent($event)"
          (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
      ></lm-detail-section-dashboard>
      <lm-detail-section-url #detailListComponent
          *ngSwitchCase="'link'"
          [panel]="panel"
          [fromDataView]="fromDataView"
          [activated]="true"
          [needsReload]="panel.needsReload"
          (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
      ></lm-detail-section-url>
      <lm-detail-section-notfound #detailListComponent
          *ngSwitchDefault
          [activated]="true"
          (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
      ></lm-detail-section-notfound>
    </div>
  </ng-container>
</ng-container>
